<template>
	<div>
		<div class="website-home">
			<!-- banner -->
			<div class="website-banner">
				<el-carousel indicator-position="none">
					<el-carousel-item v-for="item in banners" :key="item.id">
						<img :src="globalSrc + item.picPath" alt="烟台市蓝天环境资产管理有限公司">
					</el-carousel-item>
				</el-carousel>
			</div>
			<!-- 公司实力 -->
			<div class="website-company-strength">
				<div class="website-company-strength-container">
					<div class="website-company-img">
						<img src="@/assets/gssl.png" alt="烟台市蓝天环境资产管理有限公司">
					</div>
					<div class="website-item">
						<div class="item-num">{{companyInformation.members}}<span>户</span></div>
						<div class="item-text">服务用户</div>
					</div>
					<div class="website-item">
						<div class="item-num">{{companyInformation.managementArea}}<span>㎡</span></div>
						<div class="item-text">管理面积</div>
					</div>
				</div>
			</div>
			<!-- 新闻中心 -->
			<div class="website-news">

				<div class="website-news-container">

					<div class="website-news-container-img">
						<img src="@/assets/news-log.png" alt="烟台市蓝天环境资产管理有限公司">
					</div>

					<div class="website-news-container-title">
						企业资讯
					</div>

					<div class="website-news-container-content">

						<div class="item" v-for="item in newsData" :key="item.id">
							<div class="item-img">
								<img :src="globalSrc + item.iconUrl" alt="烟台市蓝天环境资产管理有限公司">
							</div>
							<div class="year-month">
								<div class="year">{{item.addDate}}</div>
							</div>
							<div class="title">{{item.title}}</div>
						</div>

					</div>

					<div class="website-news-btn" @click="handleJump(2)" style="cursor: pointer;">全部新闻</div>

				</div>

			</div>

			<!-- 业务方案 -->
			<div class="website-ywfa">
				<div class="website-ywfa-container">
					<div class="website-ywfa-container-img">
						<img src="@/assets/yw-logo.png" alt="烟台市蓝天环境资产管理有限公司">
					</div>
					
					<div class="website-ywfa-imgs">
						<div class="ywfa-item-img">
							<div class="item-content">
								<img src="@/assets/ywfa11.png" alt="烟台市蓝天环境资产管理有限公司">
								<p style="margin-top: 30px;">智慧环境综合治理服务</p>
							</div>
							<div class="box-gb1"></div>
							<div class="hover-bg"></div>
						</div>
						<div class="ywfa-item-img">
							<div class="item-content">
								<img src="@/assets/ywfa22.png" alt="烟台市蓝天环境资产管理有限公司">
								<p style="margin-top: 30px;">城市物业智慧运营服务</p>
							</div>
							<div class="box-gb2"></div>
							<div class="hover-bg"></div>
						</div>
						<div class="ywfa-item-img">
							<div class="item-content">
								<img src="@/assets/ywfa33.png" alt="烟台市蓝天环境资产管理有限公司">
								<p style="margin-top: 30px;">基于物联网的环境行业</p>
								<p style="margin-top: 10px;">软硬件研发</p>
							</div>
							<div class="box-gb3"></div>
							<div class="hover-bg"></div>
						</div>
						<div class="ywfa-item-img">
							<div class="item-content">
								<img src="@/assets/ywfa44.png" alt="烟台市蓝天环境资产管理有限公司">
								<p style="margin-top: 30px;">数智产业园开发</p>
							</div>
							<div class="box-gb4"></div>
							<div class="hover-bg"></div>
						</div>
						<div class="ywfa-item-img">
							<div class="item-content">
								<img src="@/assets/ywfa55.png" alt="烟台市蓝天环境资产管理有限公司">
								<p style="margin-top: 30px;">阿狸弄潮传媒</p>
							</div>
							<div class="box-gb5"></div>
							<div class="hover-bg"></div>
						</div>
					</div>
					
					
				</div>
			</div>

			<!-- 项目案例 -->
			<div class="website-xmal">
				<div class="website-xmal-container">

					<div class="website-xmal-title">精选项目案例</div>

					<div class="back-title" style="margin-bottom: 40px;">{{projectCase.title}}</div>

					<p class="item-p" v-for="item in projectCase.serviceContentArr">{{item}}</p>
					<!-- <p class="item-p">1.城区实行以“一户一桶一芯片”为核心的生活垃圾四分类模式；</p>
					<p class="item-p">2.村居实行以“城乡环卫一体化”为基础，以“一户双桶”为核心的上门分类收集模式；</p>
					<p class="item-p">3.公共机构可回收物和有害垃圾收运；</p>
					<p class="item-p">4.公共区域垃圾点位封闭式改造。</p> -->
					
					
					
					
					<div class="more-btn" @click="handleJump(4)" style="cursor: pointer;">MORE+</div>

					<div class="item-person">
						<img :src="globalSrc + projectCase.homePicPath" alt="烟台市蓝天环境资产管理有限公司">
					</div>


				</div>

				<div class="website-tips">
					<div class="website-tips-container">
						<div class="tm1">环境行业领军者</div>
						<div class="tm2">ENVIRONMENTAL INDUSTRY LEADER</div>

					</div>
				</div>



			</div>

			<!-- 产品中心 -->
			<div class="website-cpzx">

				<div class="website-cpzx-container">
					<div class="website-cpzx-container-left">

						<div style="margin-top: 160px;">
							<img src="@/assets/cpzx-logo.png" alt="">
						</div>
						<div class="tm" style="margin-top: 160px;">垃圾分类设备种类多样，品种齐全。</div>
						<div class="tm">主要包括：投递亭系列、投递房系列、投递箱系列等。</div>
						<div class="more-btn" style="cursor: pointer;" @click="handleJump(5)">MORE+</div>

					</div>
					<div class="website-cpzx-container-right">

						<div class="right-up">
							<div class="item">
								<div>
									<img :src="globalSrc + (productImages[0]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
								</div>
								<div class="tt">
									{{productImages[0]?.productName || ''}}
								</div>
							</div>
							<div class="item">
								<div>
									<img :src="globalSrc + (productImages[1]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
								</div>
								<div class="tt">
									{{productImages[1]?.productName || ''}}
								</div>
							</div>
						</div>

						<div class="right-down">
							<div class="item">
								<div>
									<img :src="globalSrc + (productImages[2]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
								</div>
								<div class="tt">
									{{productImages[2]?.productName || ''}}
								</div>
							</div>
							<div class="item">
								<div>
									<img :src="globalSrc + (productImages[3]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
								</div>
								<div class="tt">
									{{productImages[3]?.productName || ''}}
								</div>
							</div>
						</div>


					</div>
				</div>
			</div>

			<!-- 资质荣誉 -->

			<div class="website-zzry">
				<div class="website-zzry-container">
					<div class="zzry-logo">
						<img src="@/assets/zzry-logo.png" alt="烟台市蓝天环境资产管理有限公司">
					</div>
					<p style="margin-top: 50px;">蓝天环境目前已取得市政三级施工总承包资质、环保三级施工总承包资质、安全生产许可资质、环境、安全、质量管理体系认证。</p>
					<p style="margin-top: 20px;">同时在行业中积极发挥引导作用，公司同时担任山东省固废产业协会副会长单位，垃圾分类专业指导委员会主任委员单位。</p>
					<div class="images-container" ref="side">
						<div class="img-item" v-for="item in ryzzImgs" :key="item.id" ref="imgs">
							<img :src="globalSrc + item.picPath" alt="烟台市蓝天环境资产管理有限公司">
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 手机端 -->
		<div class="mobile-website-home">
			<!-- banner -->
			<div class="mobile-website-banner" v-if="showBanner">
				<el-carousel indicator-position="none" height="auto">
					<el-carousel-item v-for="(item,index) in banners" :key="item.id"
						:style="{height:bannerImgHeight + 'px'}">
						<img :src="globalSrc + item.mobilePicPath" ref="bannerImg" alt="烟台市蓝天环境资产管理有限公司"
							v-on:load="handleImageLoad(index)">
					</el-carousel-item>
				</el-carousel>
			</div>
			<!-- 公司实力 -->
			<div class="mobile-website-company-strength">
				<div class="mobile-website-company-strength-container">
					<div class="mobile-website-company-img">
						<img src="@/assets/mobile/mobile-home/mobile-gssl.png" alt="烟台市蓝天环境资产管理有限公司">
					</div>
					<div class="mobile-website-item">
						<div class="mobile-item-num">{{companyInformation.members}}<span>户</span></div>
						<div class="mobile-item-text">服务用户</div>
					</div>
					<div class="mobile-website-item">
						<div class="mobile-item-num">{{companyInformation.managementArea}}<span>㎡</span></div>
						<div class="mobile-item-text">管理面积</div>
					</div>
				</div>
			</div>
			<!-- 新闻中心 -->
			<div class="mobile-website-news">
				<div class="mobile-news-title-img">
					<img src="@/assets/mobile/mobile-home/mobile-xwzx.png" alt="" class="news-img" />
				</div>

				<div class="mobile-news-container" v-if="mobileNewsData">

					<div class="mobile-news-pic">
						<img :src="globalSrc + mobileNewsData.iconUrl" alt="烟台市蓝天环境资产管理有限公司" />
					</div>

					<div class="mobile-news-flex">
						<div class="mobile-news-time">
							{{mobileNewsData.addDate}}
						</div>
						<div></div>
					</div>
					<div class="mobile-news-body">
						<div class="t1">{{mobileNewsData.categoryName}}</div>
						<div class="t2">{{mobileNewsData.title}}</div>
					</div>

				</div>

				<div class="mobile-news-btn" @click="handleJump(2)">全部新闻</div>

			</div>

			<!-- 业务方案 -->
			<div class="mobile-website-ywfa">
				<div class="mobile-ywfa-title-img">
					<img src="@/assets/mobile/mobile-home/mobile-ywfa-title.png" alt="" class="ywfa-img" />
				</div>

				<div class="mobile-ywfa-body">

					<div class="item-flex">
						<div class="item item1">
							<div class="item-img">
								<img src="@/assets/ywfa11.png" alt="" srcset="" />
								<p>智慧环境综合治理服务</p>
							</div>
						</div>
						<div class="item item2">
							<div class="item-img">
								<img src="@/assets/ywfa22.png" alt="" srcset="" />
								<p>城市物业智慧运营服务</p>
							</div>
						</div>
					</div>

					<div class="item-flex" style="margin-top: 10px;">
						<div class="item item3">
							<div class="item-img">
								<img src="@/assets/ywfa33.png" alt="" srcset="" />
								<p>基于物联网的环境行业软硬件研发</p>
							</div>
						</div>
						<div class="item item4">
							<div class="item-img">
								<img src="@/assets/ywfa44.png" alt="" srcset="" />
								<p>数智产业园开发</p>
							</div>
						</div>
					</div>

					<div class="item-ywfa">
						<img src="@/assets/ywfa55.png" alt="" srcset="" />
						<p>阿狸弄潮传媒</p>
					</div>
				</div>
			</div>

			<!-- 项目案例 -->
			<div class="mobile-website-xmal">
				<div class="mobile-website-xmal-container">
					<div class="mobile-website-xmal-title">精选项目案例</div>
					<div class="container-title">{{projectCase.title}}</div>
					<p class="item-p" v-for="item in projectCase.serviceContentArr">{{item}} </p>
					<div class="more-btn" style="cursor: pointer;" @click="handleJump(4)">MORE+</div>
				</div>
			</div>

			<!-- 环境行业领军者 -->
			<div class="mobile-website-tips">
				<div class="mobile-website-tips-container">
					<div class="tm1">环境行业领军者</div>
					<div class="tm2">ENVIRONMENTAL INDUSTRY LEADER</div>
				</div>
			</div>

			<!-- 产品中心 -->
			<div class="mobile-website-cpzx">
				<div class="mobile-cpzx-title-img">
					<img src="@/assets/mobile/mobile-home/mobile-cpzx-title.png" alt="" class="cpzx-img" />
				</div>
				<div class="mobile-cpzx-title">
					垃圾分类设备种类多样，品种齐全。主要包括：投递亭系列、投递房系列、投递箱系列、车辆等。
				</div>
				<div class="mobile-cpzx-body">
					
					<div class="mobile-cpzx-item">
						<img :src="globalSrc + (productImages[0]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
						<p>{{productImages[0]?.productName || ''}}</p>
					</div>
					
					
					<div class="mobile-cpzx-item">
						<img :src="globalSrc + (productImages[1]?.picPath || '')" alt="烟台市蓝天环境资产管理有限公司">
						<p>{{productImages[1]?.productName || ''}}</p>
					</div>
				</div>
				<div class="mobile-cpzx-more-btn" style="cursor: pointer;" @click="handleJump(5)">MORE+</div>

			</div>
			<!-- 资质荣誉 -->
			<div class="mobile-website-zzry">
				<div class="mobile-zzry-title-img">
					<img src="@/assets/mobile/mobile-home/mobile-zzry-title.png" alt="" class="zzry-img" />
				</div>
				<div class="zzry-item">
					<p>蓝天环境目前已取得市政三级施工总承包资质、环保三级施工总承包资质、</p>
					<p>安全生产许可资质、环境、安全、质量管理体系认证。</p>
					<p>同时在行业中积极发挥引导作用，公司同时担任山东省固废产业协会副会长单位，</p>
					<p>垃圾分类专业指导委员会主任委员单位。</p>
				</div>
				<div class="mobile-images-container" ref="mobileSide">
					<div class="mobile-img-item" v-for="item in mobileRyzzImgs" :key="item.id" ref="imgs">
						<img :src="globalSrc + item.mobilePicPath" alt="烟台市蓝天环境资产管理有限公司">
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script setup>
	import {
		onBeforeUnmount,
		onMounted,
		ref
	} from 'vue';

	import {
		getNewsList,
		getHomeDynamicList,
		getContactUsList,
		getTalentList
	} from '@/api/api.js'

	import {
		globalSrc
	} from '@/utils/global.js'


	import {
		useRouter
	} from 'vue-router';


	import {
		useStore
	} from '@/store/store.js'

	const store = useStore()



	const router = useRouter()


	const showBanner = ref(true)



	const banners = ref([{
			"id": 0,
			"src": require('../../assets/banner1.png'),
			"mobileSrc": require('../../assets/mobile/mobile-home/mobile-banner1.png')
		},
		{
			"id": 1,
			"src": require('../../assets/banner2.png'),
			"mobileSrc": require('../../assets/mobile/mobile-home/mobile-banner2.png')
		},
		{
			"id": 2,
			"src": require('../../assets/banner3.png'),
			"mobileSrc": require('../../assets/mobile/mobile-home/mobile-banner3.png')
		}
	])


	const ryzzImgs = ref([

		{
			"id": 1,
			"src": require('../../assets/ryzz/ryzz1.png')
		},
		{
			"id": 2,
			"src": require('../../assets/ryzz/ryzz2.png')
		},
		{
			"id": 3,
			"src": require('../../assets/ryzz/ryzz3.png')
		},
		{
			"id": 4,
			"src": require('../../assets/ryzz/ryzz4.png')
		},
		{
			"id": 5,
			"src": require('../../assets/ryzz/ryzz5.png')
		},
		{
			"id": 6,
			"src": require('../../assets/ryzz/ryzz6.png')
		},
		{
			"id": 7,
			"src": require('../../assets/ryzz/ryzz7.png')
		},
		{
			"id": 8,
			"src": require('../../assets/ryzz/ryzz8.png')
		},

	]) 



	const mobileRyzzImgs = ref( [

		{
			"id": 1,
			"src": require('../../assets/ryzz/ryzz1.png')
		},
		{
			"id": 2,
			"src": require('../../assets/ryzz/ryzz2.png')
		},
		{
			"id": 3,
			"src": require('../../assets/ryzz/ryzz3.png')
		},
		{
			"id": 4,
			"src": require('../../assets/ryzz/ryzz4.png')
		},
		{
			"id": 5,
			"src": require('../../assets/ryzz/ryzz5.png')
		}
		// {
		// 	"id": 6,
		// 	"src": require('../../assets/ryzz/ryzz6.png')
		// },
		// {
		// 	"id": 7,
		// 	"src": require('../../assets/ryzz/ryzz7.png')
		// },
		// {
		// 	"id": 8,
		// 	"src": require('../../assets/ryzz/ryzz8.png')
		// },

	])


	const side = ref(null)
	const mobileSide = ref(null)
	const interval = ref(null)
	const mobileInterval = ref(null)
	const newsData = ref([])
	const mobileNewsData = ref()
	const bannerImg = ref(null)
	const bannerImgHeight = ref(null)
	
	
	
	
	const companyInformation = ref({})
	const projectCase = ref({})
	const productImages = ref([])
	
	
	
	
	
	const handleJump = (e) => {
		if (e === 2) {
			router.replace({
				path: '/web-site/news',
				query: {
					id: e
				}
			})
		}
		if (e === 4) {
			router.replace({
				path: '/web-site/project',
				query: {
					id: e
				}
			})
		}
		if (e === 5) {
			router.replace({
				path: '/web-site/product',
				query: {
					id: e
				}
			})
		}
	}
	const newsList = () => {
		getNewsList({
			pageIndex: 0,
			pageSize: 4
		}).then(result => {

			if (result.status === "Ok") {
				newsData.value = result.data
				mobileNewsData.value = result.data[0]
			}

		})
	}
	newsList()

	let updateBannerImgHeightListener;
	let getScreenWidthListener;
	// let w = 0;

	const move = () => {
		const imgs = document.querySelectorAll('.img-item');
		side.value.appendChild(imgs[0])
	}

	const mobileMove = () => {
		if (showBanner.value == true) {
			const imgs = document.querySelectorAll('.mobile-img-item');
			mobileSide.value.appendChild(imgs[0])
		}
	}

	const handleImageLoad = (index) => {
		updateBannerImgHeight(index)
		updateBannerImgHeightListener = () => {
			updateBannerImgHeight(index)
		}
		window.addEventListener("resize", updateBannerImgHeightListener);
	}

	// 获取手机端banner图片高度
	const updateBannerImgHeight = (index) => {
		// console.log(index)
		if (showBanner.value == true) {
			const imgHeight = bannerImg.value[index].clientHeight
			bannerImgHeight.value = imgHeight
		}
	}
	// 动态获取屏幕宽度
	const getScreenWidth = () => {
		getScreenWidthListener = () => {
			let w = window.innerWidth

			// console.log("resize", w)

			if (w < 768) {

				if (!mobileInterval.value) {
					clearInterval(interval.value)
					interval.value = null
					mobiliInter()
				}
			} else {
				if (!interval.value) {
					clearInterval(mobileInterval.value)
					mobileInterval.value = null
					inter()
				}
			}
		}
		window.addEventListener('resize', getScreenWidthListener)
	}

	// 1920
	const inter = () => {
		interval.value = setInterval(() => {
			move()
		}, 5000)
	}
	// 手机
	const mobiliInter = () => {

		if (showBanner.value == true) {
			mobileInterval.value = setInterval(() => {
				mobileMove()
			}, 6000)
		}
	}
	getScreenWidth()
	onBeforeUnmount(() => {


		showBanner.value = false

		if (interval.value != null) {
			clearInterval(interval.value)
			interval.value = null
			side.value = null
		}
		if (mobileInterval.value != null) {
			clearInterval(mobileInterval.value)
			mobileInterval.value = null
			mobileSide.value = null
		}


		// console.log('interval', interval.value)
		// console.log('mobileInterval', mobileInterval.value)



		// 清除  window.addEventListener('resize')
		window.removeEventListener('resize', updateBannerImgHeightListener);
		window.removeEventListener('resize', getScreenWidthListener);
	})


	//获取首页内容

	const getHomeDynamicData = (data) => {
		getHomeDynamicList({}).then(result => {
			// console.log('HomeData',result)
			if(result.status === "Ok"){
				banners.value = result.data.carouselImages
				companyInformation.value = result.data.companyInformation
				projectCase.value = result.data.projectCase
				productImages.value = result.data.productImages
				ryzzImgs.value = result.data.honorsImageInfos
				mobileRyzzImgs.value = result.data.honorsImageInfos
			}
		})
	}
	
	//联系我们
	const getUsList = () => {
		getContactUsList({}).then(result=>{
			if(result.status === "Ok") store.usList = result.data[0]
			
		})
	}
	
	//人才战略
	const getRcList = () => {
		getTalentList({}).then(result=>{
			//  console.log('rc',result)
			if(result.status === "Ok") store.peopleList = result.data
		})
	}
	
	
	
	
	onMounted(() => {
		// console.log('interval', interval.value)
		// console.log('mobileInterval', mobileInterval.value)
		let w = window.innerWidth
		// console.log('w', w)
		if (w < 768) {
			if (interval.value) {
				clearInterval(interval.value)
				interval.value = null

				// side.value = null
			}
			mobiliInter()
		} else {
			if (mobileInterval.value) {
				clearInterval(mobileInterval.value)
				mobileInterval.value = null

				// mobileSide.value = null
			}
			inter()
		}
		getHomeDynamicData()
		getRcList()
		getUsList()
	})
</script>

<style>
	@media screen and (min-width:768px) {
		.el-carousel__container {
			height: 784px !important;
		}
	}
</style>




<style lang="scss" scoped>
	@import "@/styles/website-home.scss";
</style>